<!doctype html>
<html lang="de">
<head>
    <meta charset="utf-8">
    <title></title>
    <style>
        /* Sinnvolle Defaults für den Druck im Iframe */
        @page { margin: 12mm; }
        html, body { background: #fff; }
        /* Scrollcontainer im Druck komplett öffnen */
        [style*="overflow"], .overflow-auto, .overflow-y-auto, .overflow-x-auto {
            overflow: visible !important;
            height: auto !important;
            max-height: none !important;
        }
        /* Falls UI-Klassen aus eurer App mitkopiert wurden */
        .noPrint { display: none !important; }
    </style>
</head>
<body>
    <div id="chat-widget">
        <div id="print-root"></div>
    </div>
</body>
</html>